import { useTranslate } from '@common/hooks'
import Button from '@common/widgets/Button'
import cx from 'classnames'
import React, { useEffect, useRef, useState } from 'react'

import classNames from './styles.module.scss'


interface IProps {
  children: React.ReactNode;
}

export default function ReadMoreWrapper({ children }: IProps): JSX.Element {
  const [isExpanded, setIsExpanded] = useState(false)
  const [showButton, setShowButton] = useState(false)
  const [isDisabledReadMore, setIsDisabledReadMore] = useState(false)
  const contentRef = useRef<HTMLDivElement | null>(null)
  const { translate } = useTranslate()

  useEffect(() => {
    if(contentRef.current && contentRef.current.offsetHeight < 150) {
      setIsDisabledReadMore(true)
    }
    setShowButton(true)
  }, [])

  return (
    <section className={classNames.wrapper}>
      <div
        className={cx(classNames.readMore, !isExpanded && !isDisabledReadMore && classNames.blocked)}
      >
        <div className={classNames.content} ref={contentRef}>
          {children}
        </div>
      </div>
      {!isDisabledReadMore && (
        <>
          {showButton && (
            <Button
              className={classNames.showMoreButton}
              onClick={() => setIsExpanded(state => !state)}
              variant="transparent"
              data-test="show-toggle-btn"
            >
              {isExpanded ? translate('Show less') : translate('Show more')}
          </Button>
          )}
          {!isExpanded && <div className={classNames.mask} />}
        </>
      )}
    </section>
  )
}
